module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible && _vm.message && _vm.menuMessage(_vm.message.message)) ? _c('li', {
    class: {
      'self': _vm.message && _vm.message.self, 'other': _vm.message && !_vm.message.self
    }
  }, [_c('messageMenu', {
    ref: "menuMessage",
    attrs: {
      "message": _vm.message
    }
  })], 1) : (_vm.message && _vm.surveyMessage(_vm.message.message)) ? _c('li', {
    class: {
      'self': _vm.message && _vm.message.self, 'other otherSurvey': _vm.message && !_vm.message.self
    }
  }, [(_vm.isFaces(_vm.message.message)) ? _c('messageSurvey', {
    ref: "surveyMessage",
    attrs: {
      "message": _vm.message
    }
  }) : (_vm.isYesNo(_vm.message.message)) ? _c('messageSurveyYesNo', {
    attrs: {
      "message": _vm.message
    }
  }) : _vm._e()], 1) : (_vm.message && _vm.visible) ? _c('li', {
    class: {
      'self': _vm.message && _vm.message.self, 'other': _vm.message && !_vm.message.self
    }
  }, [_c('div', {
    staticClass: "containerMessage"
  }, [_c('div', {
    staticClass: "msg",
    style: ({
      'background-color': _vm.message && !_vm.message.self ? _vm.$store.state.campaign.color : '#e8e7e7'
    })
  }, [_vm._l((_vm.getEnters(_vm.message.message)), function(item, index) {
    return _c('p', {
      directives: [{
        name: "linkify",
        rawName: "v-linkify"
      }],
      key: index,
      class: {
        'black-text': _vm.message && _vm.message.self
      },
      style: ({
        'color': _vm.invertColor(_vm.$store.state.campaign.color)
      }),
      attrs: {
        "message": item
      }
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "files": _vm.message.attachments
    }
  })], 2), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$moment(_vm.message.date).format('HH:mm')))])])]) : (_vm.visible) ? _c('li', {
    staticClass: "other"
  }, [_c('div', {
    staticClass: "load-3 msg padding-typing",
    style: ({
      'background-color': _vm.$store.state.campaign.color
    })
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6f61c82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/message.vue
// module id = 418
// module chunks = 2